module.exports = __webpack_public_path__ + "media/images/fr_ca/performance-index-continuum-full-72b107cf96a0dc09650b266513fa1147.jpg";